import React from "react";
import { GlobalHeroCardStyles } from "../Styles";
import { getMeaning } from "../../utils/localization";
import { Box, Typography, Container } from "@mui/material";

const GlobalHeroCard = () => {
  return (
    <Box
      sx={[
        GlobalHeroCardStyles.HeroParentCard,
        {
          position: "relative",
          width: "100%",
          height: { xs: "200px", sm: "300px", md: "400px", lg: "400px" }, // Responsive heights
          // height: { xs: "200px", sm: "300px", md: "500px", lg: "600px" }, // Responsive heights
          overflow: "hidden",
        },
      ]}
    >
      <Box sx={GlobalHeroCardStyles.OverLayContainer} />

      <Container maxWidth="md" sx={GlobalHeroCardStyles.TitleSubTitleTxtCard}>
        <Typography
          variant="h3"
          sx={[
            GlobalHeroCardStyles.JoinNetworkTxt,
            {
              fontSize: {
                xs: "1rem",
                sm: "1.4rem",
                md: "1.9rem",
                lg: "2.2rem",
              },
            },
          ]}
        >
          {getMeaning("JOINNTWRK.JNNTWRKHDNG")}
        </Typography>
        <Typography
          variant="h6"
          sx={[
            GlobalHeroCardStyles.JoinNetworkSubHeadingTxt,
            {
              fontSize: {
                xs: "0.8rem",
                sm: "1.3rem",
                md: "1.5rem",
                lg: "1.6rem",
              },
            },
          ]}
        >
          {getMeaning("JOINNTWRK.JNNTWRKSBHDNG")}
        </Typography>
      </Container>
    </Box>
  );
};

export default GlobalHeroCard;
